import React, { useEffect, useRef } from "react";
import axios from "axios";
import { useAuth } from "../App";
import { toast } from "sonner";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

const AuthCallback = () => {
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      const hash = window.location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (!sessionIdMatch) {
        toast.error("Erro na autenticação");
        window.location.href = "/";
        return;
      }

      const sessionId = sessionIdMatch[1];

      try {
        const response = await axios.post(
          `${API}/auth/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );

        const { user } = response.data;
        setUser(user);
        
        toast.success(`Bem-vindo, ${user.name}!`);
        
        // Use window.location for reliable redirect (avoids React state race condition)
        if (user.role === "admin") {
          window.location.href = "/admin";
        } else if (user.role === "professor") {
          window.location.href = "/professor";
        } else {
          window.location.href = "/dashboard";
        }
      } catch (error) {
        console.error("Auth error:", error);
        toast.error("Erro na autenticação. Por favor tenta novamente.");
        window.location.href = "/";
      }
    };

    processAuth();
  }, [setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FDFCF6]">
      <div className="text-center">
        <div className="w-16 h-16 border-4 border-[#0F4C81] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <h2 className="font-['Syne'] text-2xl font-bold text-[#0F4C81] mb-2">A iniciar sessão...</h2>
        <p className="text-[#475569]">Por favor aguarda um momento</p>
      </div>
    </div>
  );
};

export default AuthCallback;
